const axios = require('axios');

import {
	serverUrl,
	presighnedUrl
} from '../properties'
const dataUrl = serverUrl;

export default {
	namespaced: true,
	state:{
		salesList:[],
		salesCount:0,
	},
	mutations:{
		setSalesList:(state, data) => {
			state.salesList  = data;
		},
		setSalesCount:(state, data) => {
			state.salesCount  = data;
		}
	},
	getters:{
		getSalesCount:(state, getters) => {
			return state.salesCount
		}
	},
	actions:{
		getList: ({ commit, state, rootGetters, rootState }, payload) => {
			return new Promise((resolve, reject) => {

				let payload = {
					resultsPerPage: sessionStorage.getItem("sales:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					q: rootState.searchFilterString
				}

				axios({
					url: dataUrl + '/sales/list',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						commit("setSalesList", response.data.data)
						commit("setSalesCount", response.data.count)
						resolve(response.data.data)
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
	   },
	   getCogsList:({commit, state, rootGetters, rootState }, payload)=> {
		   return new Promise((resolve, reject) => {
			   axios({
				   url: dataUrl + '/sales/cogsList',
				   method: 'POST',
				   headers: rootGetters.fetchHeader,
				   data: payload,
				   responseType: 'json'
			   }).then((response) => {
				   if (response.data) {
					   resolve(response.data)
				   }
			   }).catch((error) => {
				   console.log(error)
				   commit('hideLoadingSpinner', null, { root: true })
			   })
		   })
	   }
   }
}
